import { css, SerializedStyles } from '@emotion/core'
import React from 'react'

interface VerticalTextDividerProps {
  className?: string
  height?: string
  width?: string
  color?: string
  marginLeftRight?: string
  translateX?: string
  translateY?: string
  cssStyles?: SerializedStyles
}

const VerticalTextDivider: React.FunctionComponent<VerticalTextDividerProps> = ({
  className,
  height = '20px',
  width = '1px',
  color = '#909090',
  marginLeftRight = '0.5rem',
  translateX = '0',
  translateY = '5px',
  cssStyles = css``,
}) => {
  return (
    <span
      className={className}
      css={[dividerStyle(height, width, color, marginLeftRight, translateX, translateY), cssStyles]}
    />
  )
}

export default VerticalTextDivider

const dividerStyle = (
  height: string,
  width: string,
  color: string,
  marginLeftRight: string,
  translateX: string,
  translateY: string
) => css`
  display: inline-block;
  pointer-events: none;
  height: ${height};
  width: ${width};
  background-color: ${color};
  margin: 0 ${marginLeftRight};
  transform: translateX(${translateX}) translateY(${translateY});
`
